import { Gender } from "@/models/Gender"

export const useGenders = () => {
  const genders = [
    new Gender(Gender.MALE),
    new Gender(Gender.FEMALE),
    new Gender(Gender.OTHER),
  ].map(gender => ({
    value: gender.value,
    text: gender.label(),
  }))

  return { genders }
}
